import { getCookieByName } from '../utils/functions';
import { useBundlesPrices } from './useBundlesPrices';

export function useShowFramePlusLensesPrice() {
  const showFramePlusLensesPriceValueCookie = getCookieByName(
    'showFramePlusLensesPrice',
    true
  );

  const bundlesEnabled = useBundlesPrices();

  if (bundlesEnabled) {
    window.rxcBrain.showFramePlusLensesPrice = true;
    return true;
  }

  if (showFramePlusLensesPriceValueCookie !== null) {
    window.rxcBrain.showFramePlusLensesPrice =
      showFramePlusLensesPriceValueCookie;
    return showFramePlusLensesPriceValueCookie as boolean;
  }

  window.rxcBrain.showFramePlusLensesPrice = false;

  return false;
}
